import React from "react";
import { Star } from "lucide-react";
import { Button, deleteIconButtonClass } from "@/components/ui/button";
import { X } from "lucide-react";

export type PvPredeterminadoItem = {
  codigo: string;
  nombre: string;
  sucursalLabel?: string;
  tag?: string;
  codigoDisplay?: string;
};

interface PvPredeterminadoListProps {
  items: PvPredeterminadoItem[];
  defaultCodigo: string | null | undefined;
  onDefaultChange: (codigo: string) => void;
  onRemove?: (codigo: string) => void;
  emptyText?: string;
  radioName?: string;
}

export function PvPredeterminadoList({
  items,
  defaultCodigo,
  onDefaultChange,
  onRemove,
  emptyText = "No hay puntos de venta asignados",
  radioName = "pv-predeterminado",
}: PvPredeterminadoListProps) {
  if (items.length === 0) {
    return (
      <div className="text-center py-4 text-sm text-muted-foreground">
        {emptyText}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {items.map((pv) => {
        const isDefault = pv.codigo === defaultCodigo;
        return (
          <div
            key={pv.codigo}
            className={`flex items-center justify-between gap-3 p-3 border rounded-lg ${
              isDefault ? "border-primary bg-muted/70" : "border-border bg-muted/50"
            }`}
          >
            <div className="flex-1 min-w-0">
              <div className="font-medium text-sm flex items-center gap-1.5">
                {isDefault ? (
                  <Star className="h-3.5 w-3.5 fill-current text-primary shrink-0" />
                ) : null}
                <span>{pv.nombre || pv.codigo}</span>
                {pv.tag ? (
                  <span className="text-[10px] uppercase tracking-wide text-primary font-medium">
                    {pv.tag}
                  </span>
                ) : null}
              </div>
              <div className="text-xs text-muted-foreground">
                {pv.sucursalLabel ? `${pv.sucursalLabel} · ` : ""}
                Código: {pv.codigoDisplay || pv.codigo}
              </div>
            </div>
            <label className="flex items-center gap-2 text-sm shrink-0 cursor-pointer">
              <input
                type="radio"
                name={radioName}
                checked={isDefault}
                onChange={() => onDefaultChange(pv.codigo)}
                className="h-4 w-4 accent-primary"
              />
              <span className={isDefault ? "font-medium" : "text-muted-foreground"}>
                Predeterminado
              </span>
            </label>
            {onRemove ? (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => onRemove(pv.codigo)}
                className={deleteIconButtonClass}
              >
                <X className="h-4 w-4" />
              </Button>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
